
import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import styles from './styles.module.scss';
import EditableText from "@/components/EditableText";
import EditableImage from "@/components/EditableImage";
import clsx from "classnames";
import PropTypes from "prop-types";

export default function TileCard2({
    className,
    post,
    with_hyperlink
}) {


    return (
        <Card className={`${clsx(className, styles.root)} ${post.image || post.icon?.url ? "with-image" : "no-image"}`}>
            {post.icon?.url ? (
                <div className='image-wrapper'>
                    <img
                        className={`mb-3`}
                        src={post?.icon?.url || "/images/placeholders/icon-placeholder.png"}
                        alt={post.title}
                        height={`100%`}
                    />
                </div>
                ) : post.image ? (
                    <div className='image-wrapper'>
                        <EditableImage
                            className={`mb-3`}
                            img={`${post?.image ? post.image : "/site-assets/images/img-placeholder.jpg"}`}
                            size={"x200"}
                            alt={`${post.title}`}
                            height={`100%`}
                        />
                    </div>
            ) : null}
            {with_hyperlink ?
                <div className='post-title'><a href={`${post?.url}`} target="_self">{post.title} </a></div>
                :
                <div className='post-title'>{post.title}</div>
            }
            {post.content && (
                <div className='post-content' dangerouslySetInnerHTML={{ __html: post.content }} />
            )}
        </Card>
    )
}
TileCard2.defaultProps = {
    pathPrefix: "",
    className: "p-4",
};

TileCard2.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};